// component
import Navbar4 from "../../../components/navbars/Navbar4";
import Footer from "../../../components/footer/Footer";
import { useParams, useNavigate } from "react-router-dom";
import { Card, Container } from "react-bootstrap";

import Hero from "./Hero";
import { useEffect, useContext } from "react";
import useState from "react-usestateref";
import { getProgramInfo, getProgramInfoImage } from "../../../services/apiCore";
import CenterContext from "../../../utils/CenterContext";
import { isLoggedIn } from "../../../services/AuthService";
import Navigation from "./Navigation";
import ProgramSessions from "./ProgramSessions";
import defaultImage from "../../../assets/images/Placeholder.png";
import ProgramPromotion from "./ProgramPromotion";
import ProgramEnrollmentModal from "./ProgramEnrollmentModal";

const ProgramDetail = () => {
  const navigate = useNavigate();
  const { center } = useContext(CenterContext);
  // const location = useLocation();
  // const id = location?.state?.id;
  const { id } = useParams();
  const [img, setImg] = useState();
  const [program, setProgram] = useState();
  const [sessions, setSessions] = useState();
  const [selectedSession, setSelectedSession] = useState();
  const [showEnrollmentBtn, setShowEnrollmentBtn] = useState(false);
  const [params, setParams] = useState();
  const [showEnrollmentModal, setShowEnrollmentModal] = useState(false);

  useEffect(() => {
    setParams({
      programId: id,
      centerId: program?.center?.id,
      categoryId: program?.programOnlineEnrollmentSetting?.categoryId,
      isShow: true,
      pageNumber: 1,
      pageSize: 3,
      isOrderByAsc: true,
    });

    if (!!center) {
      setShowEnrollmentBtn(
        isLoggedIn() && String(center?.id) === String(program?.center.id)
      );
    }
  }, [program]);

  useEffect(() => {
    function adjustFontSize() {
      const textNodes = getTextNodes(document.body);
      document.body.style.setProperty("--size", localStorage.size);
      textNodes.forEach(node => {
        const orignFontSize = parseInt(window.getComputedStyle(node.parentNode).fontSize);
      if (node.parentNode.style.getPropertyValue("--sorignFontSize") == '') {
        node.parentNode.style.setProperty("--sorignFontSize", orignFontSize + "px");
        node.parentNode.style.fontSize = `calc(var(--sorignFontSize) * var(--size))`;
      }
    });
  }
  /* getnodes */
  function getTextNodes(node) {
    let textNodes = [];
    if (node.nodeType === Node.TEXT_NODE) {
      textNodes.push(node);
    } else {
      const children = node.childNodes;
      if (children) {
        for (let i = 0; i < children.length; i++) {
          textNodes = textNodes.concat(getTextNodes(children[i]));
        }
      }
    }
    return textNodes;
  }
  async function fetchDataAndAdjust() {
    await fetchData();
    setTimeout(function () {
      adjustFontSize();
    }, 1000); //await
  }
  fetchDataAndAdjust();
    window.scrollTo({ top: 0, behavior: "smooth" });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const fetchData = async () => {
    const img = (await getProgramInfoImage(id))?.data;
    setImg(img ? img : defaultImage);

    const result = await getProgramInfo({ ProgramId: id });
    if (!result?.data?.items[0]) {
      alert("沒有活動資料");
      navigate(-1);
    } else {
      const newSessions = result?.data?.items[0].programSessions;
      setProgram(result?.data?.items[0]);
      setSessions(newSessions);
    }
  };

  const handleSelectedSession = (selectedSession) => {
    setSelectedSession(
      sessions.find((item) => String(item.id) === String(selectedSession))
    );
  };

  const handleShowEnrollmentModal = () => setShowEnrollmentModal(true);

  const handleCloseEnrollmentModal = () => {
    setShowEnrollmentModal(false);
    handleRefreshAfterEnrollment();
  };

  const handleRefreshAfterEnrollment = () => {
    fetchData();
  };

  return (
    <>
      {/* header */}
      <Navbar4 fixedWidth />
      {/* <Navigation></Navigation> */}
      <section className="position-relative bg-gradient2">
        <Container>
          <Card className="p-3">
            <Hero
              program={program}
              img={img}
              sessions={sessions}
              showEnrollmentBtn={showEnrollmentBtn}
              handleShowEnrollmentModal={handleShowEnrollmentModal}
            />
            <ProgramSessions
              sessions={sessions}
              handleSelectedSession={handleSelectedSession}
              selectedSession={selectedSession}
            ></ProgramSessions>
            <ProgramPromotion params={params}></ProgramPromotion>
          </Card>
          <ProgramEnrollmentModal
            program={program}
            show={showEnrollmentModal}
            handleClose={handleCloseEnrollmentModal}
            sessions={sessions}
            selectedSession={selectedSession}
          ></ProgramEnrollmentModal>
        </Container>
      </section>
      <Footer />
    </>
  );
};

export default ProgramDetail;
